import { gql } from "@apollo/client";

export const newScheduleMutation = gql `
mutation($input: ScheduleInput!){
    newSchedule(input: $input) {
      response
      message
    }
}
`;

export const UpdateScheduleByField = gql `
mutation($input: updateScheduleByField!){
  updateScheduleByField(input: $input) {
    response
  }
}
`;

export const updateScheduleMutation = gql`
mutation($input: ScheduleUpdateInput!){
  updateSchedule(input: $input) {
    response
    message
  }
}
`;

export const deleteScheduleByScheduleIdMutation = gql`
mutation($scheduleId: String!, $reason: String, $comment: String){
  deleteScheduleByScheduleId(scheduleId: $scheduleId, reason: $reason, comment: $comment) {
    message
    response
  }
}
`;


export const scheduleUpdateBulkByField = gql`
mutation($bulkScheduleUpdateInput: bulkScheduleUpdateInput!){
  updateBulkScheduleByField(bulkScheduleUpdateInput: $bulkScheduleUpdateInput) {
    message
    response
  }
}
`;

export const markSchedulesInvoicedMutation = gql`
mutation($items: JSON!){
  markSchedulesInvoiced(items: $items) {
    message
    response
  }
}
`;


export const scheduleBulkDeleteDutiesMutation = gql`
mutation($scheduleIds: JSON!, $reason: String, $comment: String){
  deleteScheduleByScheduleIds(scheduleIds: $scheduleIds, reason: $reason, comment: $comment) {
    message
    response
  }
}
`;


export const publishOpenDutiesMutation = gql`
mutation($filter: OpenDutiesPublishFilterInput!){
  publishOpenDutiesByFilter(filter: $filter) {
    message
    response
  }
}
`;